export const checkLighting = (element) => {
  // Create a temporary canvas to extract frame data
  if (!element) return 0;
  
  const isVideo = element.tagName === "VIDEO";
  const w = isVideo ? element.videoWidth : (element.naturalWidth || element.width);
  const h = isVideo ? element.videoHeight : (element.naturalHeight || element.height);

  if (!w || !h) return 0;
  
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = w;
  canvas.height = h;

  // Draw current video frame or image on canvas
  ctx.drawImage(element, 0, 0, canvas.width, canvas.height);

  // Get pixel data
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  let totalBrightness = 0;
  let count = 0;

  // Loop through pixels (RGBA → every 4 values)
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];

    // Calculate brightness using simple average
    const brightness = (r + g + b) / 3;
    totalBrightness += brightness;
    count++;
  }
  const avgBrightness = totalBrightness / count;
  // Return brightness level
  return avgBrightness;
};